import axios from "axios";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
// import { ElMessage } from "element-plus";
import {ElMessageBox, ElMessage} from "element-plus";
import router from "../router";

axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
// 请求头签名相关开始
var client_id = 'imBeHizDV7';
var client_secret = '6IRD2k7pAcEAyHbfccfYkKGapxA7yDcG';
var xappid = "yoobo";
function chineseToUnicode(str) {
  return str.split('').map(char => {
    const code = char.charCodeAt(0);
    return code > 255 ? '\\u' + code.toString(16).padStart(4, '0') : char;
  }).join('');
}
// 请求头签名相关结束

//创建axios实例
const service = axios.create({
  //axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: config.request_http,
  //超时时间
  timeout: 12000,
});

//请求拦截器
service.interceptors.request.use(
  (config) => {
    NProgress.start();
    if (config.url.includes("payapi.yogoo.net")) {
      console.log("跳过签名")
    }
    else {

      // config.headers["AppId"] = xappid;
      // config.headers["X-API-Key"] = client_id;
      var X_API_Timestamp = Date.now();
      var X_API_Nonce = Math.floor(Math.random() * 1000000) + 1;
      config.headers["X-API-Timestamp"] = X_API_Timestamp;
      // config.headers["X-API-Nonce"] = X_API_Nonce;
      // 串联 Header 参数
      // var headerString = "X-API-Timestamp=" + X_API_Timestamp;
      var headerString = X_API_Timestamp;
      var method_str = config.method.toUpperCase();

      // 组合签名串
      // var ToSignurl =config.baseURL+config.url.substring(1, 1000);
      var ToSignurl = config.url;
      config.headers["X-API-Path"] = ToSignurl;
      var parm_data_str = JSON.stringify(config.data);
      if (parm_data_str == undefined){
        parm_data_str = '{}'
      }
      var stringToSign = "";
      if (method_str === "GET") {
        stringToSign = method_str + "\n" +
          headerString + "\n" +
          ToSignurl;
      } else {
        stringToSign = method_str + "\n" +
          headerString + "\n" +
          ToSignurl + "\n" +
          parm_data_str;
      }
      // console.log("==stringToSign=1=\n",stringToSign);
      const crypto = require('crypto-browserify');
      const hash = crypto.createHmac('sha256', client_secret);
      hash.update(stringToSign.toString());
      const Hashresult = hash.digest('hex');
      const Hashbase64 = btoa(Hashresult);
      config.headers["X-API-Signature"] = Hashbase64;
      // console.log("==Hashbase64==\n",Hashbase64);
    }

    // if (token) {
    //   // 判断是否存在token，如果存在的话，则每个http header都加上token
    //   config.headers.Authorization = `Bearer ${token}`; // 根据实际情况自行修改
    // }
    // 每次发送请求之前判断vuex中是否存在token
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    const token = store.state.token;
    // console.log("==token=",token)
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3,
});

//响应拦截器
service.interceptors.response.use(
  (res) => {
    // console.log("=response1=",res)
    // console.log("response.data 的类型:", typeof res);
    
    NProgress.done();
    // console.log("--20241128---request-------",res.status);
    if (res.status === 200) {
      // console.log(res);
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  },
  (error) => {
    NProgress.done();
    // console.log("--20241128---request-------",error);
    if (error.response.status === 403 || error.response.status === 401) {
      // 403 说明 token 验证失败
      sessionStorage.clear();
      // let data2 = {
      //   userName: '',
      // };
      // this.$store.commit("setUserInfo", data2);
      // this.$store.commit("setUserName", '');
      //
      router.push({name: 'Login'});
      
    } else if (!error.response.status) {
      ElMessage({
        showClose: true,
        message: "服务异常",
        type: "warning",
      });
    }
    
    return Promise.reject(error);
    // console.log("-----request-------", error);


    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
  }
);

// 新增 fetch 请求函数
async function fetchRequest(url, options = {}) {
  NProgress.start();
  
  // 设置默认请求头
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "AppId": xappid,
    "X-API-Key": client_id,
    ...options.headers,
  };

  // 生成签名
  var X_API_Timestamp = Date.now();
  var X_API_Nonce = Math.floor(Math.random() * 1000000) + 1;
  headers["X-API-Timestamp"] = X_API_Timestamp;
  headers["X-API-Nonce"] = X_API_Nonce;
  
  var method_str = options.method ? options.method.toUpperCase() : "GET";
  var stringToSign = method_str + "\n" +
    `X-API-Key=${client_id}&X-API-Nonce=${X_API_Nonce}&X-API-Timestamp=${X_API_Timestamp}\n` +
    ('/' + url) + "\n" + // 使用 config.request_http
    (method_str !== "GET" ? JSON.stringify(options.body) : "");
  // JSON.stringify(config.data);
  // console.log("==stringToSign2=\n",stringToSign)
  // console.log("==stringToSign2=\n",JSON.stringify(options.body))
  const crypto = require('crypto-browserify');
  const hash = crypto.createHmac('sha256', client_secret);
  hash.update(stringToSign.toString());
  const Hashresult = hash.digest('hex');
  const Hashbase64 = btoa(Hashresult);
  headers["X-API-Signature"] = Hashbase64;

  // 添加 Authorization 头
  const token = store.state.token;
  headers.Authorization = `Bearer ${token}`;

  try {
    const response = await fetch(config.request_http + url, { // 使用 config.request_http
      method: method_str,
      headers: headers,
      body: method_str !== "GET" ? JSON.stringify(options.body) : null,
    });

    NProgress.done();

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.body; // 返回可读流
  } catch (error) {
    NProgress.done();
    console.error("Fetch error:", error);
    throw error;
  }
}

export default service;
export { fetchRequest }; // 导出 fetchRequest 函数

